module.exports = __webpack_public_path__ + "9f9760838b398890eab90437a2b69856.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pattern/8.svg
// module id = 703
// module chunks = 0